import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import * as Sentry from '@sentry/react';
import amplitude from 'amplitude-js';
import { removeMessageFromMessageBody, toggleSpinner } from 'apps/auth/actions/appAction';
import { updateExtraByName } from 'apps/auth/actions/extraAction';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { FRAUD_SUSPICIOUS_SCREEN_SHOWN, FROZEN_ACCOUNT_SCREEN_SHOWN } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { FROM } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { FRAUD_BLOCK_DISCLAIMER_MODAL } from 'apps/auth/constants/ComponentNames';
import { SOFT_BLOCK } from 'apps/auth/constants/Constants';
import { SHOW_FROZEN_DISCLAIMER } from 'apps/auth/constants/ExtraNames';
import { AUTH_SEND_MAIN_LINK } from 'apps/auth/constants/UrlConstants';
import { usePageMessages } from 'apps/auth/hooks/selectors';

const FraudBlockInfoModal = (props) => {
    const { fraudBlockInfoTitle, fraudBlockSoftErrorText, fraudBlockRecipientErrorText, continueButton, notNowButton } = usePageMessages();

    useEffect(() => {
        if (props.showFrozenListDisclaimer) {
            amplitude.getInstance().logEvent(FROZEN_ACCOUNT_SCREEN_SHOWN);
        } else if (props.amplitudeScreenActivity) {
            amplitude.getInstance().logEvent(FRAUD_SUSPICIOUS_SCREEN_SHOWN, {
                [FROM]: props.amplitudeScreenActivity,
            });
        }
        Sentry.captureMessage('Fraud block error', {
            extra: {
                ball_id: props.ballId || '',
                countryId: props.countryId,
                errorCode: props.error.errorCode,
                errorMessage: props.error.errorMessage,
                screenActivity: props.amplitudeScreenActivity || '',
            },
            level: 'info',
        });
    }, [props.amplitudeScreenActivity]);

    const onNotNowClick = () => {
        if (props.showFrozenListDisclaimer) {
            props.modalRef.current?.close();
            props.updateExtraByName(SHOW_FROZEN_DISCLAIMER, false);
        } else {
            let expires, messageId;
            if (props.messages) {
                props.messages.forEach((element) => {
                    expires = element.expires;
                    messageId = element.messageId;
                });
            }
            if (props.errorType === SOFT_BLOCK) {
                props.removeMessageFromMessageBody(messageId, expires, props.isAuth).then(() => {
                    props.toggleSpinner(true);
                    window.location.href = AUTH_SEND_MAIN_LINK;
                });
            }
        }
    };

    const getText = () => {
        return (props.error.errorCode === 616 || props.error.errorCode === 642) && !props.isUsaUser ? fraudBlockRecipientErrorText : fraudBlockSoftErrorText;
    };

    return (
        <>
            <ModalComponent isVerticalCentered canCloseModal={false} modalRef={props.modalRef}>
                <InfoPage
                    insideModalComponent
                    iconName="id-card-80"
                    iconColor="primary"
                    headerText={fraudBlockInfoTitle}
                    secondaryText={<div dangerouslySetInnerHTML={{ __html: getText() }} />}
                    topButtonCaption={notNowButton}
                    topButtonType="button"
                    topButtonOnClick={onNotNowClick}
                    primaryButtonCaption={continueButton}
                    primaryButtonType="button"
                    primaryButtonOnClick={() => {
                        props.setModal(FRAUD_BLOCK_DISCLAIMER_MODAL);
                    }}
                    isTagA
                />
            </ModalComponent>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        messages: state.app.messageBody,
        isAuth: state.auth.authUser,
        ballId: state.auth.ballId,
        countryId: state.auth.countryId,
        showFrozenListDisclaimer: state.extra.showFrozenDisclaimer,
        amplitudeScreenActivity: state.extra.amplitude_screen_activity,
    };
};

export default connect(mapStateToProps, {
    toggleSpinner,
    removeMessageFromMessageBody,
    updateExtraByName,
})(FraudBlockInfoModal);
